export default "https://cdn-static.gokick.com/assets/bae15fb1898ed89c0d72225e63ca082ea63e0d65/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";